module.exports = __webpack_public_path__ + "img/sn-vk.21b66a36.svg";